module.exports = __webpack_public_path__ + "static/bg.f02170ad.jpg";